import React, { useEffect, useState } from "react";
import {
  Trash2,
  Plus,
  RotateCcw,
  Save,
  ArrowLeft,
  Calendar,
} from "lucide-react";
import CONFIG from "../../config";
import { getCustomerProductList } from "../../services/customerServices";
import { notify } from "../../components/Common/Alerts";
import Utils from "../../utils";
import { useTranslation } from "react-i18next";
import { decryptData } from "../../utils/crypto";
import {
  getAllUnitsList,
  getAllVendorList,
} from "../../services/commonServices";
import { createStockEntry } from "../../services/stockEntryServices";

const StockEntry = () => {
  const brandOrange = "#ea580c";
  const storedData = JSON.parse(localStorage.getItem(CONFIG.login_data));
  const { t } = useTranslation();

  const [notes, setNotes] = useState("");
  const [products, setProducts] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [unitsList, setUnitsList] = useState([]);
  const unitOptions = unitsList || [];
  const [vendorList, setVendorList] = useState([]);

  const data =
    storeList?.find((opt) => opt.value === formData.store_id) || null;
  console.log("data", data);

  const generateReferenceNo = (type = "stock_in") => {
    const prefix = type === "stock_out" ? "SO" : "SI";
    const now = new Date();
    const year = now.getFullYear();
    const random = Math.floor(1000 + Math.random() * 9000);
    return `${prefix}-${year}-${random}`;
  };

  const [stockData, setStockData] = useState({
    entry_type: "stock_in",
    reference_type: "purchase",
    reference_no: generateReferenceNo("stock_in"),
    entry_date: new Date().toISOString().split("T")[0],
    vendor_id: "",
    notes: "",
    discount: 0,
    paid_amount: "",
    tax: 0,
  });

  useEffect(() => {
    if (products.length === 0) {
      addProductRow();
    }
  }, []);

  useEffect(() => {
    const data = {
      store_id: storedData?.active_store_id,
      category_ids: [],
      search: "",
      page: "",
      limit: 50,
    };

    getCustomerProductList(data)
      .then((response) => {
        const decrypted = decryptData(response.data.data);

        setProductOptions(decrypted.data || []);
      })
      .catch((err) => {
        notify.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    getAllUnitsList()
      .then((response) => {
        let decrypted = decryptData(response.data.data);
        let list = [];
        for (let i = 0; i < decrypted?.data?.length; i++) {
          list.push({
            value: decrypted.data[i].id,
            label:
              decrypted.data[i].name +
              " (" +
              decrypted.data[i].short_name +
              ")",
            short_name: decrypted.data[i].short_name,
            min_value: decrypted.data[i].min_value,
          });
        }
        setUnitsList(list);
      })

      .catch((err) => {
        notify.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(
    function () {
      const data = {
        store_id: storedData?.active_store_id,
      };

      getAllVendorList(data)
        .then((response) => {
          let decrypted = decryptData(response.data.data);
          let list = [];
          console.log("decrypted", decrypted);
          for (let i = 0; i < decrypted?.data?.length; i++) {
            list.push({
              value: decrypted.data[i].id,
              label: decrypted.data[i].name,
            });
          }
          setVendorList(list);
        })

        .catch((err) => {
          notify.error(Utils.getErrorMessage(err));
        });
    },
    [storedData?.active_store_id],
  );

  useEffect(() => {
    if (stockData.entry_type === "stock_out") {
      setStockData((prev) => ({
        ...prev,
        reference_type: "sale",
      }));
    } else {
      setStockData((prev) => ({
        ...prev,
        reference_type: "purchase",
      }));
    }
  }, [stockData.entry_type]);

  const handleProductChange = (rowId, field, value) => {
    setProducts((prev) =>
      prev.map((row) => {
        if (row.id !== rowId) return row;

        const updated = {
          ...row,
          [field]: value,
        };

        if (field === "product_id") {
          const alreadySelected = products.find(
            (p) => p.product_id === value && p.id !== rowId,
          );

          if (alreadySelected) {
            notify.error("Product already selected");
            return row;
          }
          const selected = productOptions.find(
            (p) => String(p.id) === String(value),
          );

          if (selected) {
            const defaultUnit =
              selected.units?.find((u) => Number(u.default_unit) === 1) ||
              selected.units?.[0];

            updated.product_name = selected.name;
            updated.sku = selected.sku;

            updated.availableUnits = selected.units || [];

            updated.variant_id = defaultUnit?.variant_id || "";
            updated.unit_id = defaultUnit?.unit_id || "";

            updated.unitSellingCost =
              defaultUnit?.selling_price &&
              Number(defaultUnit.selling_price) > 0
                ? defaultUnit.selling_price
                : selected.selling_price;

            updated.unitCost =
              defaultUnit?.cost_price && Number(defaultUnit.cost_price) > 0
                ? defaultUnit.cost_price
                : selected.cost_price;

            updated.quantity = selected.unit_qty;
            updated.stock_qty = selected.stock_qty;
          }
        }

        return updated;
      }),
    );
  };

  const handleUnitChange = (rowId, variantId) => {
    setProducts((prev) =>
      prev.map((row) => {
        if (row.id !== rowId) return row;

        const selectedUnit = row.availableUnits?.find(
          (u) => String(u.variant_id) === String(variantId),
        );

        if (!selectedUnit) return row;

        return {
          ...row,
          variant_id: selectedUnit.variant_id,
          unit_id: selectedUnit.unit_id,
          quantity: selectedUnit.unit_qty,
          unitSellingCost:
            Number(selectedUnit.selling_price) > 0
              ? selectedUnit.selling_price
              : row.unitSellingCost,
        };
      }),
    );
  };

  const updateRow = (id, field, value) => {
    setProducts((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              [field]: value,
            }
          : item,
      ),
    );
  };
  const addProductRow = () => {
    setProducts((prev) => [
      ...prev,
      {
        id: Date.now() + Math.random(),

        product_id: "",
        product_name: "",

        sku: "",

        quantity: "",

        unitCost: "",
        unitSellingCost: "",
        variant_id: "",
        unit_id: "",

        availableUnits: [],
      },
    ]);
  };

  const deleteProductRow = (id) => {
    if (products.length === 1) {
      notify.error("At least one product is required");
      return;
    }

    setProducts((prev) => prev.filter((p) => p.id !== id));
  };

  const resetForm = () => {
    setNotes("");

    setStockData({
      entry_type: "stock_in",
      reference_type: "purchase",
      reference_no: generateReferenceNo("stock_in"),
      entry_date: new Date().toISOString().split("T")[0],
      vendor_id: "",
    });
    setProducts([
      {
        id: Date.now(),
        product_id: "",
        product_name: "",
        sku: "",
        quantity: "",
        unitCost: "",
        unitSellingCost: "",
        variant_id: "",
        unit_id: "",
        availableUnits: [],
      },
    ]);
  };
  // Calculations
  const totalItems = products.length;
  const totalQuantity = products.reduce(
    (sum, p) => sum + (Number(p.quantity) || 0),
    0,
  );
  const subtotal = products.reduce(
    (sum, p) =>
      sum + (Number(p.quantity) || 0) * (Number(p.unitSellingCost) || 0),
    0,
  );
  const grandTotal = Math.max(0, subtotal - Number(stockData.discount || 0));

  const validateForm = () => {
    if (!products.length) {
      notify.error("Add at least one product");
      return false;
    }

    for (let row of products) {
      if (!row.product_id) {
        notify.error("Please select product");
        return false;
      }

      if (!row.quantity || Number(row.quantity) <= 0) {
        notify.error("Invalid quantity");
        return false;
      }

      if (stockData.entry_type === "stock_in" && !stockData.vendor_id) {
        notify.error("Please select vendor");
        return false;
      }

      if (Number(stockData.discount) < 0) {
        notify.error("Discount cannot be negative");
        return false;
      }

      if (Number(stockData.discount) > subtotal) {
        notify.error("Discount cannot exceed subtotal");
        return false;
      }

      if (!row.unitSellingCost || Number(row.unitSellingCost) <= 0) {
        notify.error("Invalid selling price");
        return false;
      }
      if (!stockData.reference_no) {
        notify.error("Reference number required");
        return false;
      }

      if (!stockData.entry_date) {
        notify.error("Entry date required");
        return false;
      }

      if (stockData.entry_type === "stock_out") {
        for (const row of products) {
          const selectedProduct = productOptions.find(
            (p) => Number(p.id) === Number(row.product_id),
          );

          const availableStock = Number(selectedProduct?.stock_qty || 0);
          if (availableStock <= 0) {
            notify.error(`${selectedProduct?.name} is out of stock`);
            return false;
          }

          if (Number(row.quantity) > availableStock) {
            notify.error(
              `${selectedProduct?.name} has only ${availableStock} in stock`,
            );
            return false;
          }
        }
      }

      const paid = stockData.paid_amount;

      if (paid !== undefined && paid !== null && paid !== "") {
        const paidValue = Number(paid);

        if (isNaN(paidValue)) {
          errors.push("Paid amount must be a number");
        }

        if (paidValue < 0) {
          errors.push("Paid amount cannot be negative");
        }

        // 🔥 NEW RULE: cannot exceed total
        if (paidValue > grandTotal) {
          errors.push("Paid amount cannot be greater than total amount");
        }
      }
    }

    return true;
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    const payload = {
      entry_type: stockData.entry_type,
      reference_type: stockData.reference_type,
      reference_no: stockData.reference_no,
      entry_date: stockData.entry_date,
      vendor_id: stockData.vendor_id || null,
      warehouse: stockData.warehouse || "Main Store",
      notes,
      tax_amount: stockData.tax || 0,
      discount_amount: stockData.discount || 0,
      paid_amount: stockData?.paid_amount || 0,
      products: products.map((item) => ({
        product_id: Number(item.product_id),
        sku: item.sku,
        unit_id: Number(item.unit_id),
        quantity: Number(item.quantity),
        unit_cost: Number(item.unitCost),
        selling_price: Number(item.unitSellingCost),
      })),
    };

    try {
      const response = await createStockEntry(payload);
      const decrypted = decryptData(response.data);
      notify.success(decrypted.message);
    } catch (error) {
      notify.error(Utils.getErrorMessage(error));
    }
  };

  const handleSaveAndAddAnother = async () => {
    const success = await handleSave();

    if (success) {
      resetForm();
    }
  };

  return (
    <div className="w-full min-h-screen bg-[#f8f9fa] py-6 px-4 sm:px-6 lg:px-8 font-sans text-slate-600 antialiased">
      {/* Header section */}
      <div className="max-w-[1400px] mx-auto flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
        <div>
          <h1 className="text-xl font-bold text-slate-800 tracking-tight">
            Stock Entry
          </h1>
        </div>
      </div>

      {/* Main Layout Grid */}
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">
        {/* Left Columns (Details Form & Product Table Grid) */}
        <div className="lg:col-span-2 flex flex-col gap-6">
          {/* Stock Entry Details Section */}
          <div className="bg-white rounded-xl p-5 sm:p-6 border border-slate-100 shadow-sm">
            <h2 className="text-sm font-bold text-orange-600 mb-5 tracking-wide">
              Stock Entry Details
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-4">
              <div>
                <label className="block text-xs font-semibold text-slate-500 mb-1.5">
                  Entry Type <span className="text-red-500">*</span>
                </label>
                <select
                  value={stockData.entry_type}
                  onChange={(e) => {
                    const type = e.target.value;

                    setStockData((prev) => ({
                      ...prev,
                      entry_type: type,
                      reference_no: generateReferenceNo(type),
                    }));
                  }}
                  className="w-full text-sm bg-[#f8fafc] border border-slate-200 rounded-lg p-2.5 text-slate-700 outline-none focus:border-orange-500 transition-colors"
                >
                  <option value="stock_in">Stock In</option>
                  <option value="stock_out">Stock Out</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-slate-500 mb-1.5">
                  Reference Type
                </label>

                <select
                  value={stockData.reference_type}
                  onChange={(e) =>
                    setStockData({
                      ...stockData,
                      reference_type: e.target.value,
                    })
                  }
                  className="w-full text-sm bg-[#f8fafc] border border-slate-200 rounded-lg p-2.5"
                >
                  {stockData.entry_type === "stock_in" ? (
                    <>
                      <option value="purchase">Purchase</option>
                      <option value="return">Customer Return</option>
                      <option value="transfer_in">Transfer In</option>
                      <option value="adjustment_in">Adjustment (+)</option>
                      <option value="opening_stock">Opening Stock</option>
                    </>
                  ) : (
                    <>
                      <option value="sale">Sale</option>
                      <option value="damage">Damage</option>
                      <option value="expiry">Expiry</option>
                      <option value="transfer_out">Transfer Out</option>
                      <option value="adjustment_out">Adjustment (-)</option>
                      <option value="supplier_return">Supplier Return</option>
                    </>
                  )}
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-slate-500 mb-1.5">
                  Reference No <span className="text-red-500">*</span>
                </label>

                <input
                  type="text"
                  value={stockData.reference_no}
                  onChange={(e) =>
                    setStockData({
                      ...stockData,
                      reference_no: e.target.value,
                    })
                  }
                  className="w-full text-sm bg-[#f8fafc] border border-slate-200 rounded-lg p-2.5 text-slate-700 outline-none focus:border-orange-500 transition-colors"
                />
              </div>
              <div>
                <label className="block text-xs font-semibold text-slate-500 mb-1.5">
                  Entry Date <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <input
                    type="date"
                    value={stockData.entry_date}
                    onChange={(e) =>
                      setStockData({
                        ...stockData,
                        entry_date: e.target.value,
                      })
                    }
                    className="w-full text-sm bg-[#f8fafc] border border-slate-200 rounded-lg p-2.5 pl-9 text-slate-700 outline-none focus:border-orange-500 transition-colors"
                  />

                  <Calendar className="w-4 h-4 text-slate-400 absolute left-3 top-3.5" />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-4">
              <div>
                <label className="block text-xs font-semibold text-slate-500 mb-1.5">
                  Vendor
                </label>
                <select
                  value={stockData.vendor_id || ""}
                  onChange={(e) =>
                    setStockData({
                      ...stockData,
                      vendor_id: e.target.value,
                    })
                  }
                  className="w-full text-sm bg-[#f8fafc] border border-slate-200 rounded-lg p-2.5 text-slate-700 outline-none focus:border-orange-500 transition-colors"
                >
                  <option value="">Select Vendor</option>

                  {vendorList.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-slate-500 mb-1.5">
                  Warehouse / Store <span className="text-red-500">*</span>
                </label>
                <select className="w-full text-sm bg-[#f8fafc] border border-slate-200 rounded-lg p-2.5 text-slate-700 outline-none focus:border-orange-500 transition-colors">
                  <option>Main Store</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-slate-500 mb-1.5">
                  Created By
                </label>
                <input
                  type="text"
                  disabled
                  value="Admin"
                  className="w-full text-sm bg-[#f1f5f9] text-slate-400 border border-slate-200 rounded-lg p-2.5 cursor-not-allowed"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-semibold text-slate-500 mb-1.5">
                Notes
              </label>
              <div className="relative">
                <textarea
                  maxLength={250}
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  placeholder="Enter notes (optional)..."
                  className="w-full text-sm bg-white border border-slate-200 rounded-lg p-2.5 h-20 resize-none outline-none focus:border-orange-400 transition-colors"
                />
                <span className="absolute bottom-2 right-2 text-[10px] text-slate-400 font-medium">
                  {notes.length}/250
                </span>
              </div>
            </div>
          </div>

          {/* Products Management List */}
          <div className="bg-white rounded-xl p-5 sm:p-6 border border-slate-100 shadow-sm flex flex-col">
            <h2 className="text-sm font-bold text-orange-600 mb-5 tracking-wide">
              Products
            </h2>

            {/* Mobile View - Card Layout Stack */}
            <div className="block md:hidden space-y-4">
              {products.map((product, index) => (
                <div
                  key={product.id}
                  className="p-4 bg-[#f8fafc] rounded-xl border border-slate-100 relative shadow-sm"
                >
                  <span className="absolute top-3 left-4 text-xs font-bold text-slate-400 bg-slate-200/60 px-2 py-0.5 rounded">
                    #{index + 1}
                  </span>

                  <button
                    onClick={() => deleteProductRow(product.id)}
                    className="absolute top-3 right-3 p-1.5 text-red-500 hover:bg-red-50 rounded-lg transition"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>

                  <div className="space-y-3 mt-6">
                    <div>
                      <label className="block text-[11px] font-bold text-slate-400 mb-1">
                        PRODUCT *
                      </label>
                      <select
                        value={product.product_id || ""}
                        onChange={(e) =>
                          handleProductChange(
                            product.id,
                            "product_id",
                            e.target.value,
                          )
                        }
                        className="w-full bg-white border border-slate-200 rounded-lg p-2"
                      >
                        <option value="">Select Product</option>

                        {productOptions.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="block text-[11px] font-bold text-slate-400 mb-1">
                          SKU
                        </label>
                        <input
                          type="text"
                          value={product.sku}
                          readOnly
                          className="w-full text-sm bg-[#f1f5f9] p-2 rounded-lg text-slate-400 outline-none"
                        />
                      </div>
                      <div>
                        <label className="block text-[11px] font-bold text-slate-400 mb-1">
                          UNIT
                        </label>
                        <select
                          value={product.variant_id}
                          onChange={(e) =>
                            handleUnitChange(product.id, e.target.value)
                          }
                          className="w-full bg-white border border-slate-200 rounded-lg p-2"
                        >
                          <option value="">Select Unit</option>

                          {product.availableUnits?.map((unit) => (
                            <option
                              key={unit.variant_id}
                              value={unit.variant_id}
                            >
                              {unit.unit_qty} {unit.short_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="block text-[11px] font-bold text-slate-400 mb-1">
                          QUANTITY *
                        </label>
                        <input
                          type="number"
                          value={product.quantity}
                          onChange={(e) =>
                            handleProductChange(
                              product.id,
                              "quantity",
                              e.target.value,
                            )
                          }
                          className="w-full text-sm bg-white border border-slate-200 rounded-lg p-2 text-slate-700 focus:border-orange-500 outline-none"
                        />
                      </div>
                      <div>
                        <label className="block text-[11px] font-bold text-slate-400 mb-1">
                          UNIT COST (₹) *
                        </label>
                        <input
                          type="number"
                          value={product.unitSellingCost}
                          onChange={(e) =>
                            handleProductChange(
                              product.id,
                              "unitSellingCost",
                              e.target.value,
                            )
                          }
                          className="w-full text-sm bg-white border border-slate-200 rounded-lg p-2 text-slate-700 focus:border-orange-500 outline-none"
                        />
                      </div>
                    </div>

                    <div className="pt-2 flex justify-between items-center border-t border-slate-200">
                      <span className="text-xs font-bold text-slate-400">
                        TOTAL (₹):
                      </span>
                      <span className="text-sm font-bold text-slate-700">
                        {(
                          (product.quantity || 0) *
                          (product.unitSellingCost || 0)
                        ).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop View - Tabular Layout */}
            <div className="hidden md:block overflow-x-auto">
              <table className="w-full min-w-[750px] text-left border-collapse">
                <thead>
                  <tr className="bg-[#f8fafc] text-[11px] font-bold text-slate-400 uppercase tracking-wider border-b border-slate-100">
                    <th className="p-3 w-12 text-center">#</th>
                    <th className="p-3 w-1/4">
                      Product <span className="text-red-500">*</span>
                    </th>
                    <th className="p-3">SKU</th>
                    <th className="p-3 w-24">Unit</th>
                    <th className="p-3 w-28">
                      Quantity <span className="text-red-500">*</span>
                    </th>
                    <th className="p-3 w-32">
                      Unit Cost (₹) <span className="text-red-500">*</span>
                    </th>
                    <th className="p-3 w-28 text-right">Total (₹)</th>
                    <th className="p-3 w-16 text-center">Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 text-sm">
                  {products.map((product, index) => (
                    <tr key={product.id} className="hover:bg-slate-50/50">
                      <td className="p-3 text-center text-slate-400 font-medium">
                        {index + 1}
                      </td>
                      <td className="p-3">
                        <select
                          value={product.product_id || ""}
                          onChange={(e) =>
                            handleProductChange(
                              product.id,
                              "product_id",
                              e.target.value,
                            )
                          }
                          className="w-full bg-white border border-slate-200 rounded-lg p-2"
                        >
                          <option value="">Select Product</option>

                          {productOptions.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td className="p-3 text-slate-400 font-medium">
                        {product.sku || "—"}
                      </td>

                      <td className="p-3">
                        <select
                          value={product.variant_id}
                          onChange={(e) =>
                            handleUnitChange(product.id, e.target.value)
                          }
                          className="w-full bg-white border border-slate-200 rounded-lg p-2"
                        >
                          <option value="">Select Unit</option>

                          {product.availableUnits?.map((unit) => (
                            <option
                              key={unit.variant_id}
                              value={unit.variant_id}
                            >
                              {unit.unit_qty} {unit.short_name}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td className="p-3">
                        <input
                          type="number"
                          min="1"
                          value={product.quantity}
                          onChange={(e) =>
                            updateRow(product.id, "quantity", e.target.value)
                          }
                          className="w-full bg-white border border-slate-200 rounded-lg p-2 text-center"
                        />
                      </td>
                      <td className="p-3">
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          value={product.unitSellingCost}
                          onChange={(e) =>
                            updateRow(
                              product.id,
                              "unitSellingCost",
                              e.target.value,
                            )
                          }
                          className="w-full bg-white border border-slate-200 rounded-lg p-2 text-center"
                        />
                      </td>
                      <td className="p-3 text-right font-bold text-slate-700">
                        {(
                          (product.quantity || 0) *
                          (product.unitSellingCost || 0)
                        ).toFixed(2)}
                      </td>
                      <td className="p-3 text-center">
                        <button
                          onClick={() => deleteProductRow(product.id)}
                          className="p-2 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Dotted Add Action Bar */}
            <button
              onClick={addProductRow}
              className="mt-4 w-full py-2 border-2 border-dashed border-slate-200 rounded-lg text-sm font-bold text-orange-600 hover:bg-orange-50/40 hover:border-orange-300 transition-all flex items-center justify-center gap-1.5"
            >
              <Plus className="w-4 h-4" /> Add More Product
            </button>
          </div>
        </div>

        {/* Right Sidebar Column (Summary Box & Tips) */}
        <div className="flex flex-col gap-6">
          {/* Checkout Summary Panel */}
          <div className="bg-white rounded-xl p-6 border border-slate-100 shadow-sm flex flex-col gap-4">
            <h2 className="text-sm font-bold text-orange-600 tracking-wide mb-1">
              Summary
            </h2>

            <div className="flex justify-between items-center text-sm">
              <span className="text-slate-400 font-medium">Total Items</span>
              <span className="font-bold text-slate-800">{totalItems}</span>
            </div>

            <div className="flex justify-between items-center text-sm">
              <span className="text-slate-400 font-medium">Total Quantity</span>
              <span className="font-bold text-slate-800">{totalQuantity}</span>
            </div>

            <hr className="border-slate-100" />

            <div className="flex justify-between items-center text-sm">
              <span className="text-slate-400 font-medium">Subtotal</span>
              <span className="font-bold text-slate-800">
                ₹{" "}
                {subtotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
              </span>
            </div>

            <div className="flex justify-between items-center text-sm">
              <span className="text-slate-400 font-medium">Discount</span>
              <input
                type="text"
                inputMode="numeric"
                value={stockData.discount}
                onChange={(e) =>
                  setStockData({
                    ...stockData,
                    discount: e.target.value,
                  })
                }
                className="w-20 text-center bg-[#f8fafc] border border-slate-200 rounded-md p-1 text-xs font-semibold text-slate-500 outline-none"
              />
            </div>

            <div className="flex justify-between items-center text-sm">
              <span className="text-slate-400 font-medium">Paid Amount</span>
              <input
                type="text"
                value={stockData.paid_amount}
                onChange={(e) =>
                  setStockData({
                    ...stockData,
                    paid_amount: e.target.value,
                  })
                }
                inputMode="numeric"
                className="w-20 text-center bg-[#f8fafc] border border-slate-200 rounded-md p-1 text-xs font-semibold text-slate-500 outline-none"
              />
            </div>

            <hr className="border-slate-100" />

            <div className="flex justify-between items-center pt-1">
              <span className="text-sm font-bold text-orange-600">
                Grand Total
              </span>
              <span className="text-lg font-extrabold text-orange-600">
                ₹{" "}
                {grandTotal.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                })}
              </span>
            </div>
          </div>

          {/* Business Rules Help Tooltip */}
          <div className="bg-white rounded-xl p-5 border border-slate-100 shadow-sm">
            <h3 className="text-[11px] font-bold text-slate-700 flex items-center gap-1.5 uppercase tracking-wider mb-3">
              <span className="inline-flex items-center justify-center w-4 h-4 rounded-full border border-slate-400 text-[10px] font-bold">
                i
              </span>
              Stock Entry Tips
            </h3>
            <ul className="text-xs text-slate-400 flex flex-col gap-2.5 list-disc pl-4 leading-relaxed font-medium">
              <li>
                Use <span className="font-bold text-slate-600">Stock In</span>{" "}
                for new stock, purchase, or returns.
              </li>
              <li>
                Use <span className="font-bold text-slate-600">Stock Out</span>{" "}
                for damage, expiry, or manual adjustments.
              </li>
              <li>All stock movements will be recorded in stock history.</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Global Form Sticky Footer Menu */}
      <div className="max-w-[1400px] mx-auto flex flex-col sm:flex-row justify-between items-center mt-8 pt-4 border-t border-slate-200 gap-4 mb-8">
        <button
          onClick={resetForm}
          className="flex items-center gap-1.5 text-xs font-bold text-slate-400 hover:text-slate-600 transition px-4 py-2.5 rounded-lg bg-white border border-slate-200 shadow-sm w-full sm:w-auto justify-center"
        >
          <RotateCcw className="w-4 h-4" /> Reset
        </button>
        <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
          <button
            onClick={handleSaveAndAddAnother}
            type="button"
            className="flex items-center justify-center gap-1.5 px-5 py-2.5 text-sm font-bold text-slate-700 bg-white border border-slate-200 rounded-xl hover:bg-slate-50 transition shadow-sm w-full sm:w-auto"
          >
            <Save className="w-4 h-4" /> Save & Add Another
          </button>
          <button
            type="button"
            onClick={handleSave}
            className="flex items-center justify-center gap-1.5 px-6 py-2.5 text-sm font-bold text-white bg-orange-600 hover:bg-orange-700 rounded-xl transition shadow-md shadow-orange-500/10 w-full sm:w-auto"
          >
            <Save className="w-4 h-4" /> Save Stock Entry
          </button>
        </div>
      </div>
    </div>
  );
};

export default StockEntry;
